"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DETAIL_ITEM_IMAGE = void 0;
const DETAIL_ITEM_IMAGE = exports.DETAIL_ITEM_IMAGE = 'detail-item-image';
